export default __webpack_public_path__ + "static/external-attack-a1c1c088b1c59b2ab39d9b394e39bf07.png";